import { useMemo } from "react";
import { PackageReservationState } from "@b2bportal/rbc-bundled-packages-api";
import { useFetchAllPackageReservationsQuery } from "../store/api";

export const usePackageTripStatus = (hopperReservationId: string) => {
  const { data } = useFetchAllPackageReservationsQuery();

  return useMemo(() => {
    const allReservations = [...(data?.current ?? []), ...(data?.past ?? [])];

    const match = allReservations.find(
      (item) => item.reservation.hopperReservationId === hopperReservationId
    );

    const state = match?.reservation?.state;

    const isCancelled =
      state === PackageReservationState.Cancelled ||
      state === PackageReservationState.PartiallyCancelled ||
      state === PackageReservationState.CancellationFailure ||
      state === PackageReservationState.ReservationStateFailure;

    const isPast = (data?.past ?? []).some(
      (item) => item.reservation.hopperReservationId === hopperReservationId
    );

    const isActive = !isCancelled && !isPast;

    return { state, isPast, isCancelled, isActive };
  }, [data, hopperReservationId]);
};
